import React, { Component } from 'react';
import { Button } from 'reactstrap';

export const ButonDisabled = props => {
  const handleClick = e => {
    props.handleClick();
  };

  const enabledStyle = {
    backgroundColor: '#e62333',
    color: '#fff',
    borderRadius: '999px',
    padding: '10px 24px',
    fontWeight: 600,
    border: 'none',
    boxShadow: '0 8px 24px rgba(230,35,51,0.35)',
    transition: 'all 0.25s ease',
  };

  const disabledStyle = {
    backgroundColor: '#f3a0a6',
    color: '#fff',
    borderRadius: '999px',
    padding: '10px 24px',
    fontWeight: 600,
    border: 'none',
    opacity: 0.65,
    cursor: 'not-allowed',
  };
  const style = props.disabled ? disabledStyle : enabledStyle;

  return (
    <Button
      outline
      style={style}
      onMouseEnter={e => {
        if (!props.disabled) {
          e.currentTarget.style.transform = 'translateY(-2px)';
        }
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
      }}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
    </Button>
  );
};
